import { Text } from "@idg-web-platform/pulse";
import css from "./tabs.module.css";
import classNames from "classnames";

export interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
}

/**
 * A reusable tab navigation component following the Figma design.
 * Shows tabs with an underline indicator for the active tab.
 */
export function Tabs({ tabs, activeTabId, onTabChange }: TabsProps) {
  return (
    <div className={css.tabsContainer}>
      <div className={css.tabs} role="tablist">
        {tabs.map((tab) => {
          const isActive = tab.id === activeTabId;
          return (
            <button
              key={tab.id}
              role="tab"
              aria-selected={isActive}
              className={classNames(css.tab, { [css.activeTab]: isActive })}
              onClick={() => onTabChange(tab.id)}
            >
              <Text
                sizeStep={0}
                fontStyle={isActive ? "bold" : "default"}
                removeMargin={true}
                element="span"
              >
                {tab.label}
              </Text>
            </button>
          );
        })}
      </div>
      <div className={css.tabsIndicator} />
    </div>
  );
}
